import RecordLockError from 'src/components/RecordLockError/RecordLockError';
import { connect } from 'react-redux';
import { SpecsActionCreator } from 'src/store/states';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    deptSpecs: state.Specs.deptSpecs,
});

const mapDispatchToProps = {
    getDeptSpecs: SpecsActionCreator.GetDeptSpecs,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(RecordLockError);